import './BodyText.scss';
import clsx from 'clsx';
import React from 'react';

type Props = {
  className?: string;
  children: React.ReactNode;
};

export const BodyText = ({ className, children }: Props): React.ReactElement => (
  <p className={clsx('bp-body-text', className)}>
    {children}
  </p>
);
